<template>
  <config-base ref="baseRef" v-bind="$props" :capacity-unit="capacityUnitI18nKey">
    <template #config>
      <capacity-config-list :config-plan-type="planType" :config-capacity-key="capacityKey" :capacity-unit-i18n-key="capacityUnitI18nKey" :show-monthly-price-from-cycle="true"></capacity-config-list>
    </template>
    <template #footer v-if="canRmv">
      <zm-button data-testid="checkout-button-66" type="link" ghost @click="removePlanByKey" :aria-label="'remove ' + trackingPlanKey + ' plan'">{{ $t('billing.common.remove') }}</zm-button>
    </template>
  </config-base>
</template>

<script>
import planCommon from '@/plans/LARGE_MEETING/mixin';
import {getPlanTotalLicense} from "@/common/service/validate";
import plansMixin from "@/plans/mx/plan";
import ConfigList from "@/components/capacity/config-list.vue";
import ConfigBase from "@/plans/LARGE_MEETING/config/base.vue";
import { computedCapacityLargePlans } from "@/common/service/computers/plans/large-meeting";
import { isBizPlusContext } from '@/plans/ZOOM_MEETING/common/utils';
import { planTypes } from '@/common/constants';
import autoAddMixin from "@/common/mixin/autoAdd";
import autoAddCapacityMixin from '@/plans/LARGE_MEETING/mixins/auto-add-capacity';
import { mapGetters } from 'vuex';

const CapacityConfigList = {
  name: 'CapacityConfigList',
  extends: ConfigList,
  mixins: [planCommon, autoAddMixin, autoAddCapacityMixin],
  computed: {
    ...mapGetters(['basePlanTotalLicenses']),
    mx_licenseTips() {
      return this.totalLimitDesc;
    },
    addAnotherCapacityCta() {
      return this.$t('billing.addAnother.large');
    },
  },
  methods: {
    mx_getMaxHosts() {
      if (isBizPlusContext || this.$context.is.biz2pro) {
        return getPlanTotalLicense(this.getSelectedPlans.filter(item => [planTypes.ZOOM_MEETING, planTypes.ZOOM_ONE_BUNDLE].includes(item.type))) || 999;
      }
      if (this.mx_canAutoAdd) {
        return this.mx_maxAutoAddLicense;
      }

      return this.basePlanTotalLicenses || 999;
    },
    mx_getIncreaseTips(capacity, license) {
      const currentCapacityPlanCount = getPlanTotalLicense(computedCapacityLargePlans(this.selectedPlanList || [], capacity)) || license;
      return currentCapacityPlanCount >= this.mx_getMaxHosts() ? this.totalLimitDesc : '';
    },
    handleLicenseChange(license, oldLicense, planInfo) {
      if (this.mx_canAutoAdd) {
        this.mx_handleConfigRowLicenseChange(license, planInfo);
      }
    },
  }
}
export default {
  mixins: [plansMixin, planCommon],
  components: { ConfigBase, CapacityConfigList },
  computed: {
    canRmv() {
      return this.isShowRemoveBtn
    }
  },
  methods: {
    getFirstFocusableControl() {
      return new Promise(resolve => {
        this.$nextTick(() => {
          resolve(this.$el.querySelector('.zbo-select-span__inner'))
        })
      })
    }
  },
};
</script>

<style lang="scss">
</style>
